module.exports = __webpack_public_path__ + "img/date-calendar.39d4fe14.svg";